import { memo } from "react";
import Featurelist from "./FeatureProductlist/Featurelist";

function Features({ data = [] }) {
	if (!Array.isArray(data) || data.length === 0) return null;

	return (
		<section className="overflow-x-hidden" aria-labelledby="featured-gowns-heading">
			<div className="mb-10 overflow-hidden text-center" id="collection">
				<h2 id="featured-gowns-heading" className="px-4 font-lora text-4xl font-semibold md:text-5xl">Featured Gowns</h2>
			</div>
			<ul className="mt-20 mb-16 grid grid-cols-1 gap-4 overflow-x-hidden px-4 sm:grid-cols-2 md:grid-cols-3 md:px-10 xl:grid-cols-4 lg:px-16">
				{data.slice(0, 12).map((item) => (
					<Featurelist key={item._id || item.id || item.style} data={item} />
				))}
			</ul>
		</section>
	);
}

export default memo(Features);
